import gql from "@apollo/client";

const HOUSES_QUERY_V4 = gql`
	query HOUSES_QUERY_V4($filter: String) {
		housesV4(filter: $filter) {
			data {
				id
				full
				url
				district_id
				street_id
				district_name
				street_type
				street_name
			}
		}
	}
`;
export default HOUSES_QUERY_V4;
